import React from 'react';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import {IConfigFieldDefinition} from '../../services/configurations-areas/fields-definitions/config-field-definition-base';
import Grid from '@material-ui/core/Grid';
import {ConfigurationFieldTooltipComponent} from '../configuration-field-tooltip/configuration-field-tooltip.component';

export interface FieldsBatchComponentProps {
    fields: IConfigFieldDefinition[];
}

export class FieldsBatchComponent extends LauncherComponentBase<FieldsBatchComponentProps> {
    render() {

        return (
            <Grid item>
                {this.props.fields.map(field => (<ConfigurationFieldTooltipComponent key={field.configurationKey} field={field}></ConfigurationFieldTooltipComponent>))}
            </Grid>
        );
    }
}

